// Integrations status — honest "is this configured?" flags from the server.
import { apiClient } from '../api-client';
import { INTEGRATIONS_STATUS } from '../../api-endpoints/api-endpoints';

export interface IntegrationsStatus {
  slack: { configured: boolean };
  discord: { configured: boolean };
  emailDns: { configured: boolean; provider: string | null };
  email: { provider: string; configured: boolean };
}

export const integrationsService = {
  get: (): Promise<IntegrationsStatus> => apiClient.get<IntegrationsStatus>(INTEGRATIONS_STATUS),
};
